export { default as useSelectedProduct } from './useSelectedProduct';
